import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Download, Printer, Sparkles } from 'lucide-react';

export default function AdminProposal() {
  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="max-w-6xl mx-auto space-y-8">
      {/* Special Notice Banner */}
      <div className="bg-gradient-to-br from-sky-50 to-blue-50 border-2 border-sky-200 rounded-3xl p-8 shadow-lg">
        <div className="flex items-start gap-4">
          <div className="w-12 h-12 rounded-2xl bg-sky-500 flex items-center justify-center shrink-0">
            <Sparkles className="w-6 h-6 text-white" />
          </div>
          <div className="flex-1">
            <h3 className="font-bebas text-3xl text-sky-900 tracking-wide mb-3">
              A Note From The Developer
            </h3>
            <div className="space-y-3 font-sans text-sm text-sky-900 leading-relaxed">
              <p>
                I decided that I already had these pages here, and that I see
                more potential in not half-assing the site but instead building
                it to where it's for the most part functional. If there's
                issues, just let me know.
              </p>
              <p>
                <strong>The lead generation system will work</strong> — that was
                the main thing you wanted. But the other parts of the site
                should work too, and if you need them improved or updated later
                on, at least they're there and not missing. This makes both our
                lives easier in the end.
              </p>
              <p>
                You can at least show others the custom coded site you had,
                working, and maybe that draws in more business for me later on.
                It gives you a proper site to see the potential with when you're
                ready to grow.
              </p>
              <p className="font-medium text-sky-950">
                <strong>Price terms:</strong> Simply pay what you want. We
                agreed to I think $800, but I'd rather just have you pay for
                what you can afford — $100, $200, $400, or $800. I won't ask for
                any dollar amount. Consider it good business, and I hope there's
                more to come out of this in the future.
              </p>
              <p className="italic text-sky-800">
                Quality relationships and business are valued more than any
                dollar amount. Long-term money goals, not short-term profits.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Header */}
      <div className="bg-gradient-to-br from-slate-900 to-slate-800 rounded-3xl p-10 text-white shadow-2xl">
        <div className="flex justify-between items-start flex-wrap gap-6">
          <div>
            <h1 className="font-bebas text-6xl tracking-wide">
              WINDOW CLEANING SCHOOL
            </h1>
            <p className="text-2xl text-sky-300 mt-2">
              Custom Business Platform — Final Proposal
            </p>
            <p className="text-slate-300 text-sm mt-3">
              Built with care • Delivered with flexibility • Priced with trust
            </p>
          </div>
          <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl px-7 py-5">
            <p className="uppercase tracking-widest text-xs mb-2 text-sky-300">
              Date
            </p>
            <p className="text-2xl font-bold">April 30, 2026</p>
          </div>
        </div>
      </div>

      {/* Actions */}
      <div className="flex gap-3 print:hidden">
        <Button
          onClick={handlePrint}
          size="lg"
          className="font-rajdhani font-bold tracking-wider"
        >
          <Printer className="w-4 h-4 mr-2" /> PRINT / SAVE PDF
        </Button>
        <Button
          variant="outline"
          size="lg"
          className="font-rajdhani font-bold tracking-wider"
        >
          <Download className="w-4 h-4 mr-2" /> EXPORT
        </Button>
      </div>

      {/* What's Included - All FREE except Lead Gen */}
      <div>
        <h2 className="font-bebas text-5xl mb-6 text-slate-800">
          What's Included
        </h2>
        <p className="text-lg text-slate-600 mb-8">
          Everything you need to run your window cleaning school business,
          professionally built and ready to use.
        </p>

        {/* FREE Items */}
        <div className="space-y-4 mb-8">
          {[
            {
              name: 'Professional Website',
              description:
                'Modern, responsive design with home page, course catalog, about section, and contact forms. Mobile-optimized and fast.',
            },
            {
              name: 'User & Account Management',
              description:
                'Complete admin dashboard to create, edit, and manage student accounts. Role management, profile data, and user authentication.',
            },
            {
              name: 'Course Management System',
              description:
                'Create and manage training courses with descriptions, pricing, duration, and capacity. Assign courses to students.',
            },
            {
              name: 'Appointment Booking System',
              description:
                'Students can book training sessions. Admin dashboard to view, confirm, reschedule, or cancel appointments.',
            },
            {
              name: 'Analytics & Reporting Dashboard',
              description:
                'Track website traffic, student enrollments, revenue, and appointment statistics. Visual charts and data exports.',
            },
            {
              name: 'Contact & Message Management',
              description:
                'Log all communications with leads and students. Track outreach, follow-ups, and conversation history.',
            },
            {
              name: 'Admin Dashboard',
              description:
                'Central command center with real-time stats, charts, and quick access to all management features.',
            },
            {
              name: 'Database & Hosting Setup',
              description:
                'Cloudflare Pages deployment with D1 database. Fast, secure, and scalable infrastructure.',
            },
          ].map((item, i) => (
            <Card
              key={i}
              className="border-emerald-200 bg-emerald-50/40 hover:bg-emerald-50/60 transition-colors"
            >
              <CardContent className="p-6">
                <div className="flex justify-between items-start gap-6">
                  <div className="flex-1">
                    <div className="flex items-center gap-3 mb-2">
                      <span className="w-8 h-8 rounded-lg bg-emerald-500 text-white flex items-center justify-center font-bold text-sm">
                        {i + 1}
                      </span>
                      <h3 className="font-rajdhani font-bold text-2xl text-slate-800">
                        {item.name}
                      </h3>
                    </div>
                    <p className="text-slate-600 ml-11">{item.description}</p>
                  </div>
                  <div className="text-right shrink-0">
                    <div className="relative inline-block">
                      <div className="text-3xl font-bold text-slate-400 line-through opacity-50">
                        $500
                      </div>
                      <div className="absolute -top-2 -right-2 w-16 h-16 bg-emerald-500 rounded-full flex items-center justify-center transform rotate-12">
                        <span className="text-white font-bold text-xs">
                          FREE
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Lead Generation - Pay What You Want */}
        <Card className="border-sky-300 bg-gradient-to-br from-sky-50 to-blue-50 shadow-xl">
          <CardContent className="p-8">
            <div className="flex justify-between items-start gap-6">
              <div className="flex-1">
                <div className="flex items-center gap-3 mb-3">
                  <span className="w-10 h-10 rounded-xl bg-sky-500 text-white flex items-center justify-center font-bold">
                    ⭐
                  </span>
                  <h3 className="font-bebas text-3xl text-slate-800">
                    Lead Generation System
                  </h3>
                </div>
                <p className="text-slate-700 ml-13 mb-4 text-lg">
                  Search Florida businesses by name, location, or industry. Find
                  potential clients for cold calling and prospecting. Includes
                  business details, contact information, and lead management
                  dashboard.
                </p>
                <div className="ml-13 space-y-2 text-sm text-slate-600">
                  <p>
                    ✓ Florida Secretary of State business search integration
                  </p>
                  <p>✓ Save and organize leads in your dashboard</p>
                  <p>✓ Track contact status and follow-ups</p>
                  <p>✓ Export lead lists for outreach campaigns</p>
                </div>
              </div>
              <div className="text-right shrink-0">
                <div className="mb-3">
                  <div className="text-2xl font-bold text-slate-400 line-through">
                    $800
                  </div>
                </div>
                <div className="bg-gradient-to-br from-sky-500 to-blue-600 text-white rounded-2xl px-6 py-4 shadow-lg">
                  <div className="text-sm font-medium mb-1">
                    Pay What You Want
                  </div>
                  <div className="text-3xl font-bold">$100-$800</div>
                  <div className="text-xs mt-2 opacity-90">Your choice</div>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>

      {/* Total Value */}
      <Card className="border-slate-300 bg-gradient-to-br from-slate-50 to-white shadow-2xl">
        <CardContent className="p-10">
          <div className="flex justify-between items-center flex-wrap gap-6">
            <div>
              <h2 className="font-bebas text-5xl text-slate-800 mb-2">
                Total Package Value
              </h2>
              <p className="text-slate-600 text-lg">
                Professional business platform, fully functional and ready to
                use
              </p>
            </div>
            <div className="text-right">
              <div className="text-3xl font-bold text-slate-400 line-through mb-2">
                $4,000+
              </div>
              <div className="text-7xl font-bold bg-gradient-to-r from-sky-600 to-blue-600 bg-clip-text text-transparent">
                FREE*
              </div>
              <div className="text-sm text-slate-500 mt-2">
                *Except Lead Gen: Pay What You Want
              </div>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Payment Options */}
      <Card className="border-sky-200 bg-sky-50/30">
        <CardContent className="p-10">
          <h2 className="font-bebas text-4xl mb-6 text-slate-800">
            Flexible Payment Options
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
            {[
              { amount: '$100', label: 'Starter' },
              { amount: '$200', label: 'Fair' },
              { amount: '$400', label: 'Generous' },
              { amount: '$800', label: 'Original Agreement' },
            ].map((option, i) => (
              <div
                key={i}
                className="bg-white rounded-2xl p-6 text-center border-2 border-sky-200 hover:border-sky-400 transition-colors"
              >
                <div className="text-4xl font-bold text-sky-600 mb-2">
                  {option.amount}
                </div>
                <div className="text-sm text-slate-600 font-medium">
                  {option.label}
                </div>
              </div>
            ))}
          </div>
          <p className="text-center text-slate-600 mt-6 italic">
            Choose what works for your budget. No pressure, no judgment. Just
            good business.
          </p>
        </CardContent>
      </Card>

      {/* What You Get */}
      <Card className="border-slate-200">
        <CardContent className="p-10">
          <h2 className="font-bebas text-4xl mb-6 text-slate-800">
            What You're Getting
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-slate-600">
            <div className="flex items-start gap-3">
              <span className="text-2xl">✓</span>
              <div>
                <strong className="text-slate-800">Full Source Code</strong>
                <p className="text-sm">
                  Complete ownership, no licensing fees, no vendor lock-in
                </p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <span className="text-2xl">✓</span>
              <div>
                <strong className="text-slate-800">Production Ready</strong>
                <p className="text-sm">
                  Deployed and working on Cloudflare Pages with D1 database
                </p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <span className="text-2xl">✓</span>
              <div>
                <strong className="text-slate-800">Admin Dashboard</strong>
                <p className="text-sm">
                  Full control over users, courses, appointments, and analytics
                </p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <span className="text-2xl">✓</span>
              <div>
                <strong className="text-slate-800">Mobile Responsive</strong>
                <p className="text-sm">
                  Works perfectly on phones, tablets, and desktops
                </p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <span className="text-2xl">✓</span>
              <div>
                <strong className="text-slate-800">Modern Tech Stack</strong>
                <p className="text-sm">
                  React, TypeScript, Tailwind CSS, Cloudflare infrastructure
                </p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <span className="text-2xl">✓</span>
              <div>
                <strong className="text-slate-800">Future Updates</strong>
                <p className="text-sm">
                  Easy to maintain and extend as your business grows
                </p>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Support */}
      <Card className="border-slate-200 bg-slate-50">
        <CardContent className="p-10">
          <h2 className="font-bebas text-4xl mb-6 text-slate-800">
            Ongoing Support
          </h2>
          <p className="text-slate-600 mb-6">
            I'm here to help if you run into issues or need updates. No formal
            support contract required — just reach out when you need something.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="bg-white rounded-xl p-5 border border-slate-200">
              <h3 className="font-rajdhani font-bold text-lg mb-2">
                Bug Fixes
              </h3>
              <p className="text-sm text-slate-600">
                If something breaks, I'll fix it. No charge.
              </p>
            </div>
            <div className="bg-white rounded-xl p-5 border border-slate-200">
              <h3 className="font-rajdhani font-bold text-lg mb-2">
                Questions
              </h3>
              <p className="text-sm text-slate-600">
                Need help using a feature? Just ask.
              </p>
            </div>
            <div className="bg-white rounded-xl p-5 border border-slate-200">
              <h3 className="font-rajdhani font-bold text-lg mb-2">
                Future Work
              </h3>
              <p className="text-sm text-slate-600">
                Want to add features later? We'll discuss pricing then.
              </p>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Final Note */}
      <Card className="border-slate-800 bg-slate-900 text-white">
        <CardContent className="p-10">
          <h2 className="font-bebas text-4xl mb-4">Thank You</h2>
          <p className="text-slate-300 text-lg leading-relaxed mb-4">
            This project was built with care and attention to detail. Every
            feature works, every page loads, and the whole system is ready for
            you to use.
          </p>
          <p className="text-slate-300 text-lg leading-relaxed">
            I believe in building relationships, not just websites. Pay what
            feels right, use what you need, and let's see where this goes. If
            this leads to more work down the road, great. If not, at least you
            have a solid platform to grow your business.
          </p>
          <div className="mt-8 pt-8 border-t border-slate-700">
            <p className="text-sky-300 font-medium">
              Looking forward to seeing your business thrive.
            </p>
          </div>
        </CardContent>
      </Card>

      <div className="text-center text-sm text-slate-400 pb-10 print:hidden">
        Window Cleaning School • Custom Built with ❤️ • April 2026
      </div>
    </div>
  );
}
